var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronWr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15694 7.71102L1.49994 13.368L0.0859375 11.954L5.03594 7.00401L0.0859375 2.05401L1.49994 0.640015L7.15694 6.29701C7.34441 6.48454 7.44972 6.73885 7.44972 7.00401C7.44972 7.26918 7.34441 7.52349 7.15694 7.71102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronWr);
export default __webpack_public_path__ + "static/media/chevron-wr.e13d32b0aba5c753eeec0aeb855bcbf5.svg";
export { ForwardRef as ReactComponent };